module.exports = __webpack_public_path__ + "img/coracaoRiscoVida.f7f44be6.svg";